import ChecklistTable from './ChecklistTable';

export default ChecklistTable;